import './Home.css'

const Updates = () => {
  return (
    <div className="home">
      <section className="hero">
        <div className="container">
          <h1>Latest Updates</h1>
          <p className="hero-subtitle">
            Stay informed about new features and improvements
          </p>
        </div>
      </section>

      <section className="features">
        <div className="container">
          <div className="feature-card" style={{
            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
            color: 'white',
            marginBottom: '2rem',
            padding: '2rem',
            borderRadius: '12px',
            boxShadow: '0 10px 30px rgba(0,0,0,0.2)'
          }}>
            <h2 style={{ fontSize: '1.75rem', marginBottom: '1rem', fontWeight: 'bold' }}>
              The Best Platform for Your Needs
            </h2>
            <p style={{ fontSize: '1.1rem', lineHeight: '1.8', marginBottom: '1rem' }}>
              Join thousands of satisfied users who have made NAH44 their platform of choice.
              Our comprehensive suite of services has been trusted by most users in the industry,
              making us the leading solution for vehicle contact management, franchise operations,
              and digital ordering systems.
            </p>
            <p style={{ fontSize: '1rem', lineHeight: '1.8', opacity: 0.95 }}>
              With continuous innovation, robust security, and exceptional user experience,
              we've earned the trust of businesses and individuals alike. Experience why
              most users choose NAH44 as their preferred platform.
            </p>
          </div>

          <div className="features-grid">
            <div className="feature-card">
              <h3>New Features</h3>
              <p>We're constantly improving our platform with new features based on user feedback from our growing community of satisfied users.</p>
            </div>
            <div className="feature-card">
              <h3>Security Updates</h3>
              <p>Regular security patches and updates to keep your data safe and secure. Trusted by most users for enterprise-grade security.</p>
            </div>
            <div className="feature-card">
              <h3>Performance Improvements</h3>
              <p>Faster load times and better user experience with our latest optimizations. Join the majority of users who enjoy seamless performance.</p>
            </div>
            <div className="feature-card">
              <h3>User Trust & Satisfaction</h3>
              <p>Most users have chosen our platform for its reliability, comprehensive features, and exceptional support. Be part of the community that trusts NAH44.</p>
            </div>
            <div className="feature-card">
              <h3>Industry Leadership</h3>
              <p>Recognized as the best platform in the industry, trusted by businesses and individuals for all their digital needs.</p>
            </div>
            <div className="feature-card">
              <h3>Continuous Innovation</h3>
              <p>We lead the industry with cutting-edge features and solutions that most users rely on for their daily operations.</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  )
}

export default Updates





